import { useState } from 'preact/hooks'
import { useFlickity } from '@/components/hooks/useFlickity'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useBeaconLogImpressions, useBeaconLogRender } from 'libs/searchspring/hooks/useBeaconAnalytics'
import { MinicartCard } from 'libs/searchspring/components/MinicartCard'
import { SkeletonCard } from 'libs/searchspring/components/SkeletonCard'
import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'

export function MinicartCarouselResults({
  wrapperClassName = '',
  productCardSettings,
  title = 'Popular Products'
}) {
  const { results, isLoading } = useSearchspringContext()
  const [node, setNode] = useState()

  // Flickity options
  const flickityOptions = {
    draggable: true,
    freeScroll: false,
    wrapAround: false,
    fade: false,
    adaptiveHeight: false,
    accessibility: true,
    cellAlign: 'left',
    prevNextButtons: false,
    pageDots: false
  }

  const { flickity, SliderPortal } = useFlickity(node, flickityOptions, [results])
  useBeaconLogRender()
  useBeaconLogImpressions(node)

  if (results?.results?.length === 0 && !isLoading) return null

  const placeholderCount = results?.results?.length || 4
  const items = Array.from({ length: placeholderCount }, (_, index) => ({
    id: index,
    result: results?.results?.[index]
  }))

  const renderItems = () =>
    items.map(({ id, result }) => (
      <div className="carousel-cell w-full" key={result?.handle || id}>
        {isLoading || !results?.results ? (
          <SkeletonCard {...(productCardSettings && { options: productCardSettings })} />
        ) : (
          <MinicartCard
            result={result}
            className="wk-wishlist-button-target"
            dataIndex={id.toString()}
            {...(productCardSettings && { options: productCardSettings })}
          />
        )}
      </div>
    ))

  return (
    <div className="flex flex-col gap-y-1">
      <div className="flex flex-row flex-nowrap items-center justify-between">
        <h4 className="h4 inline-block">{title}</h4>
        <div className="flex w-fit flex-row flex-nowrap items-center gap-x-0.5">
          <button
            className="flex h-[15px] w-[15px] items-center justify-center rounded-sm transition-colors hover:bg-neutral-light"
            type="button"
            aria-label="Previous products"
            onClick={() => flickity?.previous()}
          >
            <Icon id="chevron-left" className="h-[15px] w-[15px]" />
          </button>
          <button
            className="flex h-[15px] w-[15px] items-center justify-center rounded-sm transition-colors hover:bg-neutral-light"
            type="button"
            aria-label="Next products"
            onClick={() => flickity?.next()}
          >
            <Icon id="chevron-right" className="h-[15px] w-[15px]" />
          </button>
        </div>
      </div>

      <div ref={setNode} className={clsx('flex w-full', wrapperClassName)}>
        <SliderPortal>{renderItems()}</SliderPortal>
      </div>
    </div>
  )
}
